<template>
  <div class="a-tag" v-on="$listeners">
    <span class="a-tag__text"><slot /></span>
    <base-icon icon="close" />
  </div>
</template>


<script>
import BaseIcon from '@/components/atoms/BaseIcon';
export default {
  name: 'Tag',
  components: {
    BaseIcon
  }
}
</script>